exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-area[data-v-0a801256] {\n\tposition: absolute;\n\theight: 100%;\n\tmargin: auto;\n}\n", ""]);

// exports
